var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWebsiteIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33789 17C4.21541 18.5207 5.478 19.7835 6.99859 20.6612C8.51919 21.539 10.2441 22.0007 11.9999 22C13.7556 22.0007 15.4806 21.539 17.0012 20.6612C18.5218 19.7835 19.7844 18.5207 20.6619 17M3.33789 7C4.21541 5.47928 5.478 4.21651 6.99859 3.33877C8.51919 2.46103 10.2441 1.99929 11.9999 2C13.7556 1.99929 15.4806 2.46103 17.0012 3.33877C18.5218 4.21651 19.7844 5.47928 20.6619 7",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 21.95C13 21.95 14.408 20.097 15.295 17M13 2.04999C13 2.04999 14.408 3.90199 15.295 6.99999M11 21.95C11 21.95 9.592 20.098 8.705 17M11 2.04999C11 2.04999 9.592 3.90199 8.705 6.99999M9 9.99999L10.5 15L12 9.99999L13.5 15L15 9.99999M1 9.99999L2.5 15L4 9.99999L5.5 15L7 9.99999M17 9.99999L18.5 15L20 9.99999L21.5 15L23 9.99999",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsiteIcon);
export default __webpack_public_path__ + "static/media/website_icon.bf7edcacb682ec46c7d7bac0868d1640.svg";
export { ForwardRef as ReactComponent };